import { createSelector } from 'reselect';

import { Store } from '../reducers/reducers';

const errorStateSelector = (store: Store) => store.error;

export const errorMessageSelector = createSelector(errorStateSelector, (error) => error.errorMessage);
